import { useState, useEffect, Fragment } from "react";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { Checkbox } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { styled } from "@mui/material/styles";
import { SimpleTreeView } from "@mui/x-tree-view";

function TreeViewCheckbox({
  permissions,
  permissionsChecked,
  setPermissionsChecked,
  expanded,
  setExpanded,
}) {
  const StyledCheckbox = styled(Checkbox)({
    "& .MuiSvgIcon-root": {
      color: "#1A73E8",
    },
  });
  const [group, setGroup] = useState("Web - Dashboard");
  const handleToggle = (itemId, type) => {
    if (type === "permission") {
      if (permissionsChecked !== null) {
        const index = permissionsChecked.indexOf(itemId);
        if (index === -1) {
          if (!itemId.includes("View") || itemId.includes('ViewPrice')) {
            const perm = itemId.split("-");
            const module = perm[0];
            if (!permissionsChecked.some((x) => x === `${module}-View`))
              setPermissionsChecked("permission", [
                ...permissionsChecked,
                itemId,
                `${module}-View`,
              ]);
            else setPermissionsChecked("permission", [...permissionsChecked, itemId]);
          } else setPermissionsChecked("permission", [...permissionsChecked, itemId]);
        } else {
          let newPermissionsChecked;
          if (!itemId.includes("View") || itemId.includes('ViewPrice')) {
            newPermissionsChecked = permissionsChecked.filter((id) => id !== itemId);
          } else {
            const perm = itemId.split("-");
            const module = perm[0];
            newPermissionsChecked = permissionsChecked.filter((id) => !id.includes(module));
          }
          setPermissionsChecked("permission", newPermissionsChecked);
        }
      } else {
        if (!itemId.includes("View" || itemId.includes('ViewPrice'))) {
          const perm = itemId.split("-");
          const module = perm[0];
          setPermissionsChecked("permission", [itemId, `${module}-View`]);
        } else {
          setPermissionsChecked("permission", [itemId]);
        }
      }
    } else if (type === "node") {
      const permInNode = itemId.permissions.map((x) => `${itemId.moduleId}-${x.permissionName}`);
      if (permissionsChecked !== null) {
        const change = permInNode.filter((x) => permissionsChecked.indexOf(x) === -1);
        if (change.length > 0)
          setPermissionsChecked("permission", [...permissionsChecked, ...permInNode]);
        else {
          const newPermissionsChecked = permissionsChecked.filter(
            (id) => permInNode.indexOf(id) === -1
          );
          setPermissionsChecked("permission", newPermissionsChecked);
        }
      } else {
        setPermissionsChecked("permission", [...permInNode]);
      }
    } else if (type === "object") {
      const permInNode = itemId.children.flatMap((node) => {
        return node.permissions.map((x) => `${node.moduleId}-${x.permissionName}`);
      });
      if (permissionsChecked !== null) {
        const change = permInNode.filter((x) => permissionsChecked.indexOf(x) === -1);
        if (change.length > 0)
          setPermissionsChecked("permission", [...permissionsChecked, ...permInNode]);
        else {
          const newPermissionsChecked = permissionsChecked.filter(
            (id) => permInNode.indexOf(id) === -1
          );
          setPermissionsChecked("permission", newPermissionsChecked);
        }
      } else {
        setPermissionsChecked("permission", [...permInNode]);
      }
    } else if (type === "module") {
      const permInNode = itemId.children.flatMap((object) => {
        return object.children.flatMap((node) => {
          return node.permissions.map((x) => `${node.moduleId}-${x.permissionName}`);
        });
      });
      if (permissionsChecked !== null) {
        const change = permInNode.filter((x) => permissionsChecked.indexOf(x) === -1);
        if (change.length > 0)
          setPermissionsChecked("permission", [...permissionsChecked, ...permInNode]);
        else {
          const newPermissionsChecked = permissionsChecked.filter(
            (id) => permInNode.indexOf(id) === -1
          );
          setPermissionsChecked("permission", newPermissionsChecked);
        }
      } else {
        setPermissionsChecked("permission", [...permInNode]);
      }
    }
  };

  const isNodeChecked = (node) => {
    if (node.permissions) {
      return node.permissions.every((perm) =>
        permissionsChecked
          ? permissionsChecked.indexOf(`${node.moduleId}-${perm.permissionName}`) !== -1
          : false
      );
    }

    if (node.children) {
      return node.children.every((child) => isNodeChecked(child));
    }

    return false;
  };

  const isNodeIndeterminate = (node) => {
    if (node.permissions) {
      return (
        !isNodeChecked(node) &&
        node.permissions.some((perm) =>
          permissionsChecked
            ? permissionsChecked.indexOf(`${node.moduleId}-${perm.permissionName}`) !== -1
            : false
        )
      );
    }

    if (node.children) {
      return (
        node.children.some((child) => isNodeIndeterminate(child) || isNodeChecked(child)) &&
        !node.children.every((child) => isNodeChecked(child))
      );
    }

    return false;
  };

  const isPermissionChecked = (itemId) => {
    return permissionsChecked !== null && permissionsChecked.indexOf(itemId) !== -1;
  };

  const renderPermission = (perms, moduleId, objectName) =>
    perms.map((perm) => (
      <TreeItem
        key={`${moduleId}-${perm.permissionName}`}
        itemId={`${moduleId}-${perm.permissionName}`}
        onClick={() => handleToggle(`${moduleId}-${perm.permissionName}`, "permission")}
        label={
          <div style={{ fontSize: "1rem" }}>
            <Checkbox
              edge="start"
              checked={isPermissionChecked(`${moduleId}-${perm.permissionName}`)}
              onChange={() => handleToggle(`${moduleId}-${perm.permissionName}`, "permission")}
            />
            {objectName === "Inventory SKU List" && perm.permissionName === "New" ? "Sync" : 
            (objectName === "Cancel Order" || objectName === "Task Assignment") && perm.permissionName === "View" ? "Access" :
            (objectName === "Received Items" || objectName === "Shipped Items" || objectName === "Manifest To Etrax") && perm.permissionName === "Edit" ? "Resend" :
            objectName === "Replenishment" && perm.permissionName === "Edit" ? "Update" :
            perm.permissionName === "ViewPrice" ? "View Price" :
            perm.permissionName}
          </div>
        }
      ></TreeItem>
    ));

  const renderNode = (nodes) =>
    nodes.map((node) => {
      if (nodes.length > 1)
        return (
          <TreeItem
            key={`${node.moduleId}`}
            itemId={`${node.moduleId}`}
            label={
              <div style={{ fontSize: "1rem" }}>
                {isNodeIndeterminate(node) ? (
                  <StyledCheckbox
                    edge="start"
                    checked={isNodeChecked(node)}
                    indeterminate={true}
                    onChange={() => handleToggle(node, "node")}
                    onClick={handleExpandClick}
                  />
                ) : (
                  <Checkbox
                    edge="start"
                    checked={isNodeChecked(node)}
                    onChange={() => handleToggle(node, "node")}
                    onClick={handleExpandClick}
                  />
                )}
                {node.objectName}
              </div>
            }
          >
            {renderPermission(node.permissions, node.moduleId, node.objectName)}
          </TreeItem>
        );
      else return renderPermission(node.permissions, node.moduleId, node.objectName);
    });

  const renderObject = (objects) =>
    objects.map((object) => (
      <TreeItem
        key={object.objectName}
        itemId={object.objectName}
        label={
          <div style={{ fontSize: "1rem", fontWeight: "500" }}>
            {isNodeIndeterminate(object) ? (
              <StyledCheckbox
                edge="start"
                checked={isNodeChecked(object)}
                indeterminate={true}
                onChange={() => handleToggle(object, "object")}
                onClick={handleExpandClick}
              />
            ) : (
              <Checkbox
                edge="start"
                checked={isNodeChecked(object)}
                onChange={() => handleToggle(object, "object")}
                onClick={handleExpandClick}
              />
            )}
            {object.objectName}
          </div>
        }
      >
        {renderNode(object.children)}
      </TreeItem>
    ));

  const handleTreeItemToggle = (e, nodes) => {
    setExpanded(nodes);
  };
  const handleExpandClick = (event) => {
    // prevent the click event from propagating to the checkbox
    event.stopPropagation();
  };

  return (
    <Fragment>
      <ModuleGroupTab group={group} setGroup={setGroup} />
      <SimpleTreeView expandedItems={expanded} onExpandedItemsChange={handleTreeItemToggle}>
        {permissions.find((x) => group.includes(x.type) && group.includes(x.objectType)) !==
          undefined &&
          permissions
            .find((x) => group.includes(x.type) && group.includes(x.objectType))
            .modules.map((module, index) => (
              <TreeItem
                key={module.moduleName}
                itemId={module.moduleName}
                onClick={handleExpandClick}
                label={
                  <div style={{ fontSize: "1rem", fontWeight: "500", fontFamily: "inherit" }}>
                    {isNodeIndeterminate(module) ? (
                      <StyledCheckbox
                        edge="start"
                        checked={isNodeChecked(module)}
                        indeterminate={true}
                        onChange={() => handleToggle(module, "module")}
                        onClick={handleExpandClick}
                      />
                    ) : (
                      <Checkbox
                        edge="start"
                        checked={isNodeChecked(module)}
                        onChange={() => handleToggle(module, "module")}
                        onClick={handleExpandClick}
                      />
                    )}
                    {module.moduleName}
                  </div>
                }
              >
                {renderObject(module.children)}
              </TreeItem>
            ))}
      </SimpleTreeView>
    </Fragment>
  );
}

function ModuleGroupTab({ group, setGroup }) {
  return (
    <MDBox mt={1} sx={{ padding: "0 16px" }}>
      <MDButton
        variant={group === "Web - Dashboard" ? "gradient" : "outlined"}
        color="info"
        size="small"
        onClick={() => {
          setGroup("Web - Dashboard");
        }}
      >
        Web - Dashboard
      </MDButton>
      <MDButton
        sx={{ ml: 1 }}
        variant={group === "Web - Transaction" ? "gradient" : "outlined"}
        color="info"
        size="small"
        onClick={() => {
          setGroup("Web - Transaction");
        }}
      >
        Web - Transaction
      </MDButton>
      <MDButton
        sx={{ ml: 1 }}
        variant={group === "Web - Report" ? "gradient" : "outlined"}
        color="info"
        size="small"
        onClick={() => {
          setGroup("Web - Report");
        }}
      >
        Web - Report
      </MDButton>
      <MDButton
        sx={{ ml: 1 }}
        variant={group === "Handheld - Transaction" ? "gradient" : "outlined"}
        color="info"
        size="small"
        onClick={() => {
          setGroup("Handheld - Transaction");
        }}
      >
        Handheld - Transaction
      </MDButton>
    </MDBox>
  );
}

export default TreeViewCheckbox;
